import { Subject } from "rxjs";
const subject = new Subject();

export const associationService = {
    sendEvent: eventId => subject.next({ eventId }),
    listenEvents: () => subject.asObservable()
};